/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPanelExpandLeft = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-panel-expand-left_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-panel-expand-left_svg__st0"
      d="m11.6 9.7 2.3 2.3-2.3 2.3 1.4 1.4 3.7-3.7L13 8.3l-1.4 1.4z"
    />
    <path
      className="ico-panel-expand-left_svg__st0"
      d="M2 2v20h20V2H2zm6 18H4V4h4v16zm12 0H10V4h10v16z"
    />
  </Icon>
);
export { SvgPanelExpandLeft as PanelExpandLeft };
